(() => {
  if (document.documentElement.dataset.gOccasionsReady) return;
  document.documentElement.dataset.gOccasionsReady = 'true';
  const selector = '[data-g-header] [data-g-occasions]';
  const disclosures = () => [...document.querySelectorAll(selector)];
  const hasFocusTarget = target => target && target !== document.body && target !== document.documentElement;
  // Focus has really left a disclosure only when it lands on something outside it that is not one of its
  // containers. Safari does not focus links on click; inside the modal mobile menu it moves focus to the
  // <dialog> itself, which contains the disclosure. Treating that as "focus left" collapsed Shop on pointerdown,
  // so the tapped colour link moved away before the click and nothing happened.
  const leftDisclosure = (details, target) => hasFocusTarget(target) && !details.contains(target) && !target.contains(details);
  const close = (details, restoreFocus = false) => {
    if (!details.open) return;
    details.querySelectorAll('[data-g-occasions][open]').forEach(child => { child.open = false; });
    details.open = false;
    if (restoreFocus) details.querySelector(':scope > summary')?.focus();
  };
  const bind = () => {
    disclosures().forEach(details => {
      if (details.dataset.gOccasionsBound) return;
      details.dataset.gOccasionsBound = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) disclosures().forEach(other => {
          if (other !== details && !other.contains(details) && !details.contains(other)) close(other);
        });
      });
      details.addEventListener('focusout', event => {
        if (hasFocusTarget(event.relatedTarget)) {
          if (leftDisclosure(details, event.relatedTarget)) close(details);
          return;
        }
        // A browser may report body before the next link receives focus.
        // Keep that transient state open so pointer/Tab activation can finish.
        requestAnimationFrame(() => {
          if (leftDisclosure(details, document.activeElement)) close(details);
        });
      });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !details.open) return;
        // Handle keyboard dismissal before the native dialog close request. A
        // repeated Escape can make the browser's cancel event non-cancelable.
        event.preventDefault();
        event.stopPropagation();
        close(details, true);
      });
      const dialog = details.closest('dialog');
      if (!dialog || dialog.dataset.gOccasionsBound) return;
      dialog.dataset.gOccasionsBound = 'true';
      dialog.addEventListener('cancel', event => {
        const focused = document.activeElement?.closest('[data-g-occasions]');
        const expanded = focused?.open && dialog.contains(focused) ? focused : [...dialog.querySelectorAll('[data-g-occasions][open]')].at(-1);
        if (!expanded) return;
        event.preventDefault();
        close(expanded, true);
      });
      dialog.addEventListener('close', () => dialog.querySelectorAll('[data-g-occasions]').forEach(details => close(details)));
    });
  };
  document.addEventListener('click', event => {
    disclosures().forEach(details => { if (!details.contains(event.target)) close(details); });
  });
  document.addEventListener('focusin', event => {
    disclosures().forEach(details => { if (leftDisclosure(details, event.target)) close(details); });
  });
  const desktop = window.matchMedia('(min-width: 1200px)');
  desktop.addEventListener('change', () => {
    const focused = document.activeElement;
    disclosures().forEach(details => close(details));
    document.querySelectorAll('[data-g-header]').forEach(header => {
      const dialog = header.querySelector('#GiorgioMenu');
      if (desktop.matches && dialog?.open) dialog.close();
      else if (!desktop.matches && focused?.closest('.g-nav-left') && header.contains(focused)) header.querySelector('[data-g-dialog-open="GiorgioMenu"]')?.focus();
    });
  });
  document.addEventListener('shopify:section:load', bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
